import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import AcademicModal from "models/academic.modal";
import Academicimage from "../../assets/img/academic.jpeg";
import academicModal from "models/academic.modal";

const Academic = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data for academic categories
    const dummyAcademicData = [
      {
        _id: "1",
        id: "1",
        name: "CBSE",
        title: "Central Board of Secondary Education",
        logo: "https://via.placeholder.com/50/0000FF/FFFFFF?text=CBSE",
        vacancyavailable: true
      },
      {
        _id: "2",
        id: "2",
        name: "ICSE",
        title: "Indian Certificate of Secondary Education",
        logo: "https://via.placeholder.com/50/FF0000/FFFFFF?text=ICSE",
        vacancyavailable: true
      },
      {
        _id: "3",
        id: "3",
        name: "State Board",
        title: "State Board Education",
        logo: "https://via.placeholder.com/50/00FF00/FFFFFF?text=SB",
        vacancyavailable: false
      },
      {
        _id: "4",
        id: "4",
        name: "IB",
        title: "International Baccalaureate",
        logo: "https://via.placeholder.com/50/FF00FF/FFFFFF?text=IB",
        vacancyavailable: true
      },
      {
        _id: "5",
        id: "5",
        name: "Cambridge",
        title: "Cambridge International Education",
        logo: "https://via.placeholder.com/50/FFFF00/000000?text=CAM",
        vacancyavailable: true
      },
      {
        _id: "6",
        id: "6",
        name: "JEE",
        title: "Joint Entrance Examination",
        logo: "https://via.placeholder.com/50/800080/FFFFFF?text=JEE",
        vacancyavailable: true
      },
      {
        _id: "7",
        id: "7",
        name: "NEET",
        title: "National Eligibility Entrance Test",
        logo: "https://via.placeholder.com/50/008080/FFFFFF?text=NEET",
        vacancyavailable: false
      },
      {
        _id: "8",
        id: "8",
        name: "UPSC",
        title: "Union Public Service Commission",
        logo: "https://via.placeholder.com/50/FFA500/FFFFFF?text=UPSC",
        vacancyavailable: true
      },
      {
        _id: "9",
        id: "9",
        name: "SSC",
        title: "Staff Selection Commission",
        logo: "https://via.placeholder.com/50/4B0082/FFFFFF?text=SSC",
        vacancyavailable: true
      },
      {
        _id: "10",
        id: "10",
        name: "Banking",
        title: "Banking Competitive Exams",
        logo: "https://via.placeholder.com/50/DC143C/FFFFFF?text=BANK",
        vacancyavailable: false
      }
    ];
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyAcademicData);
      setCurrentPage(1);
      setPerPage(20);
    }, 1000);
  };

  // console.log(dataList, "dataListac");
  useEffect(() => {
    getListData();
  }, [location]);

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Academic Category", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          // Simulate delete operation
          setTimeout(() => {
            setDataList(prevData => prevData.filter(item => item.id !== delId));
            helper.sweetalert.toast("Academic category deleted successfully", "success");
          }, 500);
        }
      });
  };
 
 
  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = (id, value, name, title) => {
    // Simulate toggle operation
    setTimeout(() => {
      setDataList(prevData => 
        prevData.map(item => 
          item.id === id 
            ? { ...item, vacancyavailable: value }
            : item
        )
      );
      helper.sweetalert.toast(`Vacancy status updated for ${name}`, "success");
    }, 300);
  };

  const [searchQuery, setSearchQuery] = useState("");
  const filteredDataList = dataList?.filter(
    (item) =>
      item?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.title?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div className="pt-7 px-4">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">All Academic</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Button
                    size="sm"
                    to="/admin/academic/addacademic/"
                    tag={Link}
                    style={{ backgroundColor: "#080278", color: "white" }}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">SN.</th>
                    <th scope="col">Name</th>
                    <th scope="col">Icon</th>
                    <th scope="col">Sub-category Title</th>
                    <th scope="col">Vacancy</th>
                    <th scope="col" className="pl-3">
                      Action
                    </th>
                  </tr>
                </thead>
                {!isLoading && (
                  <tbody>
                    {filteredDataList?.length > 0 ? (
                      filteredDataList
                        ?.slice()
                        .reverse()
                        .map((item, index) => (
                          <tr key={item._id}>
                            <td>{index + 1}</td>
                            <td>
                              <Link to={`/admin/board/${item.id}`}>
                                {item.name}
                              </Link>
                            </td>
                            <td>
                              <img
                                src={item.logo}
                                height="25px"
                                alt={item.name}
                              />
                            </td>
                            <td>{item.title}</td>
                            <td>
                              <label className="custom-toggle custom-toggle-danger">
                                <input
                                  type="checkbox"
                                  defaultChecked={item.vacancyavailable}
                                  onChange={(e) =>
                                    handleToggle(
                                      item.id,
                                      e.target.checked,
                                      item.name,
                                      item.title
                                    )
                                  }
                                />
                                <span
                                  className="custom-toggle-slider rounded-circle"
                                  data-label-off="false"
                                  data-label-on="true"
                                ></span>
                              </label>
                            </td>
                            <td
                              className="p-0 pl-4"
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <UncontrolledTooltip
                                placement="top"
                                target="eyeTooltip"
                              >
                                Edit
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  borderRadius: "30%",
                                }}
                                id="eyeTooltip"
                                to={`/admin/academic/editacademic/${item.id}`}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </Link>

                              <UncontrolledTooltip
                                placement="top"
                                target="userTooltip"
                              >
                                Delete
                              </UncontrolledTooltip>
                              <p
                                style={{
                                  margin: "0 8px",
                                  fontSize: "15px",
                                  color: "red",
                                  marginTop: "10px",
                                  display: "inline-block",
                                  borderRadius: "20%",
                                }}
                                id="userTooltip"
                                onClick={() => handleDel(item.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </p>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="6" style={{ verticalAlign: "middle" }}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default Academic;
